export default function useLocaleKey() {
  const { locale } = useI18n({
    useScope: 'global',
  })

  // Map the lowercase locale to the SupportedLocaleKeys
  const localeKey = computed(() => formatAsPascalCase(locale.value) as SupportedLocaleKeys)

  return {
    localeKey,
  }
}
